<!-- components/SharedModal.vue -->
<template>
    <a-modal
        :open="visible"
        @ok="handleOk"
        @cancel="handleCancel"
        :width="width"
        :footer="footer"
        :cancel-button-props="{ style: { display: 'none' } }"
        :ok-button-props="{ style: { display: 'none' } }"
    >
    <slot />
    </a-modal>
</template>
  
<script>
export default {
    name: 'SharedModal',
    emits: ['update:visible', 'ok', 'cancel'],
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        width: {
            type: [String, Number],
            default: 1000
        },
        footer: {
            type: [Array, Object, null],
            default: undefined
        }
    },
    computed: {
    },
    methods: {
        handleOk() {
            this.$emit('ok')
        },
        handleCancel() {
            this.$emit('update:visible', false)
            this.$emit('cancel')
        }
    }
}
</script>
  